<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ item.title }}</h3>
            <p class="text-center">{{ itemKind().name }}</p>
            <p class="text-center">{{ item.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات ایتم</h4>
          </div>
          <div class="widget-body">
            <form id="shopform" class="form-horizontal">
              <!-- title -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">عنوان</label>
                <div class="col-lg-6">
                  <input type="text" name="title" class="form-control" :value="item.title" />
                </div>
              </div>

              <div v-if="item.itemKind == 'coin'" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد سکه</label>
                <div class="col-lg-6">
                  <input class="form-control" :value="item.coinValue" type="number" name="coinValue" id="" min="1" />
                </div>
              </div>

              <div v-if="item.itemKind == 'ticket'" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد بلیط</label>
                <div class="col-lg-6">
                  <input
                    class="form-control"
                    :value="item.ticketCount"
                    type="number"
                    name="ticketCount"
                    id=""
                    min="1"
                  />
                </div>
              </div>

              <!-- price -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">
                  هزینه {{ item.itemKind == 'coin' || item.itemKind == 'ticket' ? '(تومان)' : '(سکه)' }}</label
                >
                <div class="col-lg-6">
                  <input type="number" name="price" class="form-control" :value="price().price" />
                </div>
              </div>

              <!-- discount -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تخفیف</label>
                <div class="col-lg-6">
                  <input type="number" name="discount" class="form-control" :value="price().discount" />
                </div>
              </div>

              <!-- dollar price -->
              <div v-if="item.cashAvailable" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">هزینه دلاری</label>
                <div class="col-lg-6">
                  <input type="number" name="dollarPrice" class="form-control" :value="price().dollar" />
                </div>
              </div>

              <!-- dollar discount -->
              <div v-if="item.cashAvailable" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تخفیف دلاری</label>
                <div class="col-lg-6">
                  <input type="number" name="dollarDiscount" class="form-control" :value="price().dollarDiscount" />
                </div>
              </div>

              <div v-if="item.cashAvailable" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >آی دی آیتم در کافه بازار</label
                >
                <div class="col-lg-6">
                  <input
                    class="form-control"
                    v-model="item.cafeBazaarUniqueId"
                    name="cafeBazaarUniqueId"
                    id="cafeBazaarUniqueId"
                  />
                </div>
              </div>

              <div v-if="item.cashAvailable" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">آی دی آیتم در مای کت</label>
                <div class="col-lg-6">
                  <input class="form-control" v-model="item.myketUniqueId" name="myketUniqueId" id="myketUniqueId" />
                </div>
              </div>

              <div v-if="item.cashAvailable" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">آی دی آیتم در APPSTORE </label>
                <div class="col-lg-6">
                  <input
                    class="form-control"
                    v-model="item.appstoreUniqueId"
                    name="appstoreUniqueId"
                    id="appstoreUniqueId"
                  />
                </div>
              </div>

              <div v-if="item.cashAvailable" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">آی دی آیتم در GOOGLE</label>
                <div class="col-lg-6">
                  <input
                    class="form-control"
                    v-model="item.playstoreUniqueId"
                    name="playstoreUniqueId"
                    id="playstoreUniqueId"
                  />
                </div>
              </div>

              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id="">
                    <option value="true" :selected="item.isAvailable">فعال</option>
                    <option value="false" :selected="!item.isAvailable">غیر فعال</option>
                  </select>
                </div>
              </div>

              <!-- is isPopular -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isPopular" id="isPopular">
                    <option value="true" :selected="item.isPopular">فعال</option>
                    <option value="false" :selected="!item.isPopular">غیر فعال</option>
                  </select>
                </div>
              </div>

              <!-- order -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">ترتیب</label>
                <div class="col-lg-6">
                  <input type="number" min="0" name="order" :value="item.order" class="form-control" />
                </div>
              </div>

              <!-- check min level -->
              <div
                v-if="item.itemKind == 'Skin' || item.itemKind == 'Formation'"
                class="form-group row d-flex align-items-center mb-5"
              >
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">دسترسی با سطح کاربر</label>
                <div class="col-lg-6">
                  <input type="checkbox" name="checkMinLevel" id="checkminlevel" :checked="item.checkMinLevel" />
                </div>
              </div>

              <div v-if="item.itemKind == 'Skin'" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">عدم نمایش در حالت فلگ</label>
                <div class="col-lg-6">
                  <input type="checkbox" name="hideInFlagMode" id="hideInFlagMode" :checked="item.hideInFlagMode" />
                </div>
              </div>

              <!-- min level -->
              <div
                v-if="item.itemKind == 'Skin' || item.itemKind == 'Formation'"
                class="form-group row d-flex align-items-center mb-5"
              >
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >مینیمم سطح کاربر برای دریافت</label
                >
                <div class="col-lg-6">
                  <input type="number" class="form-control" name="minLevel" id="minlevel" :value="item.minLevel" />
                </div>
              </div>

              <!-- check license -->
              <!-- <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">دسترسی با لایسنس</label>
                <div class="col-lg-6">
                  <input type="checkbox" name="checkLicense" id="checkminlevel" :checked="item.checkLicense" />
                </div>
              </div> -->
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01 mr-4" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/shop">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Row -->
  </div>
</template>

<script>
import shopService from '../../../../services/shop';
export default {
  name: 'shopdetail',
  props: ['shopId'],
  data() {
    return {
      item: {},
    };
  },
  created() {
    this.getUserData();
  },
  methods: {
    async getUserData() {
      const item = await shopService.getItem(this.$route.query.id);
      this.item = item;
      console.log(item);
    },

    price() {
      if (this.item.coinAvailable) return { price: this.item.coinPrice, discount: this.item.coinDiscount };
      if (this.item.cashAvailable)
        return {
          price: this.item.cashPrice,
          discount: this.item.cashDiscount,
          dollar: this.item.dollarPrice,
          dollarDiscount: this.item.dollarDiscount,
        };
      return { price: 'نامشخص', discount: 'نامشخص' };
    },
    itemKind() {
      if (this.item.itemKind == 'coin') return { name: 'بسته سکه' };
      if (this.item.itemKind == 'ticket') return { name: 'بسته بلیط' };
      if (this.item.itemKind == 'Skin') return { name: 'مهره' };
      if (this.item.itemKind == 'Formation') return { name: 'ترکیب' };
      if (this.item.itemKind == 'Avatar') return { name: 'اواتار' };
      if (this.item.itemKind == 'Chat') return { name: 'ایموجی' };
      return { name: 'نامشخص' };
    },
    async save() {
      try {
        const form = document.getElementById('shopform');

        const body = {
          _id: this.item._id,
          title: form.title.value,
          isAvailable: form.isAvailable.value == 'true',
          isPopular: form.isPopular.value == 'true',
          checkLicense: false,
          checkMinLevel: form.checkMinLevel ? form.checkMinLevel.checked : false,
          hideInFlagMode: form.hideInFlagMode ? form.hideInFlagMode.checked : false,
          minLevel: form.minLevel ? form.minLevel.value : 0,
          order: form.order.value,
        };
        if (this.item.itemKind == 'coin') {
          body.cashAvailable = true;
          body.cafeBazaarUniqueId = form.cafeBazaarUniqueId.value;
          body.myketUniqueId = form.myketUniqueId.value;
          body.appstoreUniqueId = form.appstoreUniqueId.value;
          body.playstoreUniqueId = form.playstoreUniqueId.value;
          body.coinAvailable = false;
          body.cashPrice = form.price.value;
          body.cashDiscount = form.discount.value;
          body.dollarPrice = form.dollarPrice.value;
          body.dollarDiscount = form.dollarDiscount.value;
          body.coinValue = form.coinValue.value;
        } else if (this.item.itemKind == 'ticket') {
          body.cashAvailable = true;
          body.cafeBazaarUniqueId = form.cafeBazaarUniqueId.value;
          body.myketUniqueId = form.myketUniqueId.value;
          body.playstoreUniqueId = form.playstoreUniqueId.value;
          body.appstoreUniqueId = form.appstoreUniqueId.value;
          body.coinAvailable = false;
          body.cashPrice = form.price.value;
          body.cashDiscount = form.discount.value;
          body.dollarPrice = form.dollarPrice.value;
          body.dollarDiscount = form.dollarDiscount.value;
          body.ticketCount = form.ticketCount.value;
        } else {
          body.cashAvailable = false;
          body.coinAvailable = true;
          body.coinPrice = form.price.value;
          body.coinDiscount = form.discount.value;
        }
        const res = await shopService.updateItem(body);
        this.item = res;
        window.notif({ isError: false, mssg: 'اپدیت شد' });
      } catch (err) {
        console.log(err);
        window.notif({ isError: true, mssg: 'مشکلی پیش آمده' });
      }
    },
  },
};
</script>
